import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

export const APP_ROUTES: Routes = [

  { path: "", pathMatch: "full", redirectTo: "public" },
  {
    path: "public",
    data: { breadcrumb: null, },
    loadChildren: () =>
      import("./pages/public/public.module").then(
        (m) => m.PublicModule
      ),
  },
  {
    path: "home",
    data: { breadcrumb: null, },
    loadChildren: () =>
      import("./pages/private/private.module").then(
        (m) => m.PrivateModule
      ),
  },
  // 🆕 Formulario PÚBLICO de inscripción de requerimiento (PESP-0007 → Jira FSH).
  // Ruta limpia /requerimiento; gateada por correo @helicentro.com.co (OTP).
  {
    path: "requerimiento",
    loadComponent: () =>
      import("./pages/public/requerimiento/requerimiento.component").then(
        (m) => m.RequerimientoComponent
      ),
  },
  // 🆕 Formulario PÚBLICO de Tickets de Soporte Técnico (FSH-58): lo llenan
  // clientes externos. Ruta limpia /soporte; gateado por OTP a su correo (dominio
  // abierto). El comando llega por query param (?commandId= / ?c= del enlace).
  {
    path: "soporte",
    loadComponent: () =>
      import("./pages/public/soporte/soporte.component").then(
        (m) => m.SoporteComponent
      ),
  },
  // 🆕 Votación PÚBLICA del Comité de Soluciones (F3): el miembro entra por su
  // link con token único (sin login). Ruta limpia /comite/votar/<token>.
  {
    path: "comite/votar/:token",
    loadComponent: () =>
      import("./pages/public/comite-votar/comite-votar.component").then(
        (m) => m.ComiteVotarComponent
      ),
  },
  // ============================================================
  // 🆕 INICIO: Formulario PUBLICO del registro de personal por enlace - 2026-10-08
  // ============================================================
  // /registro/<codigo>: el tecnico que recibe el enlace (o escanea el QR) escribe o
  // corrige sus datos sin tener cuenta en VIVO (MDE-598, F5 = MDE-605). Sin
  // guard: la unica credencial es la sesion del propio enlace.
  {
    path: "registro/:codigo",
    loadComponent: () =>
      import("./pages/public/registro-personal/registro-personal.component").then(
        (m) => m.RegistroPersonalComponent
      ),
  },
  // ============================================================
  // 🆕 FIN: Formulario PUBLICO del registro de personal por enlace
  // ============================================================
  { path: "**", redirectTo: "public/error" }
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, {
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
